module.exports = __webpack_public_path__ + "img/lookbook_11_right.8a556455.png";